// eslint-disable-next-line no-extend-native
String.prototype.format = function format() {
	// eslint-disable-next-line prefer-rest-params
	const args = arguments
	return this.replace(/{(\d+)}/g, (match, number) => (typeof args[number] !== "undefined"
		? args[number]
		: match))
}
